import { useAuth } from '@/contexts';
import { AgoraPlanNameE } from '@/types/cyclone/models';
import { freeTrialDaysLeft, freeTrialEndMessage } from '@/utils/trialEnd';

export interface FreeTrialValidationResult {
  shouldShowBanner: boolean;
  message: string;
  /** Días de calendario hasta el último día de la prueba: 2, 1 o 0 (hoy). */
  daysRemaining: number;
}

export const useFreeTrialValidation = (): FreeTrialValidationResult => {
  const { session } = useAuth();
  const activePlan = session?.active_plan;

  const isFreeTrial = activePlan?.is_free_trial ?? false;
  const startAt = activePlan?.start_at;
  const isEventsPlan = activePlan?.agora_plan?.name === AgoraPlanNameE.EVENT;

  // Never show banner for events plan
  if (!isFreeTrial || !startAt || isEventsPlan) {
    return {
      shouldShowBanner: false,
      message: '',
      daysRemaining: -1
    };
  }

  const daysRemaining = freeTrialDaysLeft(startAt);

  // Desde 2 días antes hasta el último día, inclusive
  if (daysRemaining < 0 || daysRemaining > 2) {
    return {
      shouldShowBanner: false,
      message: '',
      daysRemaining
    };
  }

  return {
    shouldShowBanner: true,
    message: freeTrialEndMessage(daysRemaining),
    daysRemaining
  };
};
